module.exports = {
  PERSONAL_COUNTER_INCREMENT_DEBOUNCE_MS: 24000,
  RESULTS_PER_PAGE: 10,
  SEARCHES_PER_TREE: 50,
  CHECKPOINTS: {
    FIRST_SEARCH: 'firstsearch',
    FIRST_HALF_TREE_PLANTED: 'firsthalftreeplanted',
    FIRST_TREE_PLANTED: 'firsttreeplanted',
    TREE_PLANTED: 'treeplanted',
  },
};
